import { render, staticRenderFns } from "./entityDialogDis.vue?vue&type=template&id=fb0f8272&scoped=true&"
import script from "./entityDialogDis.vue?vue&type=script&lang=js&"
export * from "./entityDialogDis.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDis.vue?vue&type=style&index=0&id=fb0f8272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f8272",
  null
  
)

export default component.exports